/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseAction from './CloseAction/index'
import FullScreenButton from 'DesignSystem/FullScreenButton/index'
import ImageSeriesDate from './ImageSeriesDate/index'
import Images from './Images/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import PatientAge from './PatientAge/index'
import PatientName from './PatientName/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/Images/Content/Images/Standard/Gallery/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 id="imagegrid"
 width="calc(100vw - 30px)"
 height="calc(100vh - 30px)"
 paddingTop={dtSpaceS}
 paddingBottom={dtSpaceS}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
>
{childProps => (
<React.Fragment>
<Images
{...childProps}
  viewPath={`${viewPath}/Images`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<PatientName
  viewPath={`${viewPath}/PatientName`}
/>
<PatientAge
  viewPath={`${viewPath}/PatientAge`}
/>
<ImageSeriesDate
  viewPath={`${viewPath}/ImageSeriesDate`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<FullScreenButton
  viewPath={`${viewPath}/FullScreenButton`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}